<template>
    <div>
        <div style="overflow-x:auto; margin-top: 20px">
            <table id="bids_table" class="table table-responsive table-hover table-mail minhasDemandasTable">
                <thead>
                <tr>
                    <th>Nome</th>
                    <th>Qtde. Publicações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="field in fields">
                    <td>{{ field.name }}</td>
                    <td>{{ field.total }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            fields:{
                type:Array,
            },
        },
        data(){
            return {

            }
        },
        mounted(){

        },
        methods: {

        }
    }
</script>